import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SaveService } from '../shared/services/save.service';
import 'rxjs/add/operator/do';
import { User } from '../shared/model/user';
import { MatMenuTrigger } from '@angular/material';
import { AuthService } from '../shared/security/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  header: string;
  user: User;
  type: string;
  userName: string;
  courriel: string;

  constructor(private saveService: SaveService,
    private authService: AuthService,
    private router: Router) {

    this.saveService.titleChange.subscribe(value => this.header = value);
    this.saveService.userChange
      .subscribe(value => {
        this.user = value;
        if (this.user) {
          this.userName = `${value.firstName} ${value.lastName}`;
          if (this.user.userType === "TEMPO") {
            this.courriel = "Code Usagé";
            this.type = "Temporaire"
          } else {
            this.courriel = value.email;
            this.type = (value.userType === "ADMIN" ? "Compte responsable" : "Compte étudiant")
          }
        } else {
          this.userName = "";
          this.type = "";
          this.courriel = "";
        }
      });

  }

  ngOnInit() { }

  logout() {
    this.authService.logout();
    this.saveService.setUser(null);
    // this.router.navigate(['accueil']);
    this.router.navigate(['login']);
  }

  login() {
    this.router.navigate(['login']);
  }

  getUserType() {
    return this.saveService.getUserType()
  }

  updateUser() {
    this.router.navigate(['user-update']);
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/header/header.component.ts